(() => {
  const slugify = (value) => value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-') || 'section';

  const copyLink = async () => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(window.location.href);
      return;
    }

    const input = document.createElement('textarea');
    input.value = window.location.href;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  const initArticle = (root) => {
    if (!root || root.dataset.eiArticleReady === 'true') return;
    root.dataset.eiArticleReady = 'true';

    const content = root.querySelector('[data-ei-article-content]');
    const headings = content ? Array.from(content.querySelectorAll('h2')) : [];
    const usedIds = new Set();

    headings.forEach((heading) => {
      const base = heading.id || slugify(heading.textContent || 'section');
      let id = base;
      let suffix = 2;
      while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = `${base}-${suffix}`;
        suffix += 1;
      }
      heading.id = id;
      usedIds.add(id);
    });

    root.querySelectorAll('[data-ei-toc-list]').forEach((list) => {
      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
    });

    if (headings.length) {
      root.querySelectorAll('[data-ei-desktop-toc], [data-ei-mobile-toc]').forEach((toc) => {
        toc.hidden = false;
      });
    }

    root.querySelectorAll('[data-ei-copy-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        try {
          await copyLink();
          button.classList.add('is-copied');
          button.setAttribute('aria-label', 'Article link copied');
          root.querySelectorAll('[data-ei-copy-status]').forEach((status) => { status.textContent = 'Link copied'; });
          window.setTimeout(() => {
            button.classList.remove('is-copied');
            button.setAttribute('aria-label', 'Copy article link');
            root.querySelectorAll('[data-ei-copy-status]').forEach((status) => { status.textContent = 'Share this story'; });
          }, 1800);
        } catch (error) {
          button.setAttribute('aria-label', 'Unable to copy article link');
        }
      });
    });

    const bookmark = root.querySelector('[data-ei-bookmark]');
    if (bookmark) {
      const key = `ei-saved-article-${root.dataset.articleId}`;
      let saved = false;
      try { saved = window.localStorage.getItem(key) === 'true'; } catch (error) { saved = false; }

      const updateBookmark = () => {
        bookmark.classList.toggle('is-saved', saved);
        bookmark.setAttribute('aria-pressed', String(saved));
        bookmark.setAttribute('aria-label', saved ? 'Remove saved article' : 'Save article');
      };

      updateBookmark();
      bookmark.addEventListener('click', () => {
        saved = !saved;
        try { window.localStorage.setItem(key, String(saved)); } catch (error) { /* Storage can be unavailable. */ }
        updateBookmark();
      });
    }
  };

  const init = (scope = document) => {
    if (scope.matches && scope.matches('[data-ei-article]')) initArticle(scope);
    scope.querySelectorAll('[data-ei-article]').forEach(initArticle);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
